import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _extends from "@babel/runtime/helpers/esm/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import { Cost, OrderHeader, CartItem, CartLineGroup } from "./CartHelpers";
import { Button, Row, Col, Container, ButtonGroup, FormGroup } from "react-bootstrap";
import { AuthenticationState } from "react-aad-msal";
import { handleModNames } from "../../util";
import MediaQuery from 'react-responsive';
import AccordionFilterSelect from "../accordion/AccordionFilterSelect";
import { Field } from 'formik';
import { FormInput, FormControlledInput, RadioButton, FormCheckbox, FormSelect, StateBootstrapButton as StateButton, StateBootstrapButton } from '../forms/elements';
import UsStates from '../forms/elements/UsStates';
import { FaTimes } from "react-icons/fa";
import { Giftcard } from "./Giftcard";
import { Loading } from "../../components/state";
import FetchError from "../state/Error";
import { useFlags } from 'launchdarkly-react-client-sdk';
import { VehicleMenu } from "../landingpage/VehicleMenu";
import CarIcon from '../../images/svg/Car-Icon.svg';
import TruckIcon from '../../images/svg/Truck-Icon.svg';
import SuvIcon from '../../images/svg/SUV-icon.svg';
import VanIcon from '../../images/svg/Van-Icon.svg';
import HatchIcon from '../../images/svg/Hatchback-Icon.svg';
import OtherVehicleIcon from '../../images/svg/Other-Vehicle-Icon.svg';
import CarIconRebrand from '../../images/rebrand/svg/Car-Icon.svg';
import TruckIconRebrand from '../../images/rebrand/svg/Truck-Icon.svg';
import SuvIconRebrand from '../../images/rebrand/svg/SUV-icon.svg';
import VanIconRebrand from '../../images/rebrand/svg/Van-Icon.svg';
import HatchIconRebrand from '../../images/rebrand/svg/Hatchback-Icon.svg';
import OtherVehicleIconRebrand from '../../images/rebrand/svg/Other-Vehicle-Icon.svg';
import White from '../../images/svg/WhiteIcon.svg';
import Silver from '../../images/svg/GrayIcon.svg';
import Black from '../../images/svg/BlackIcon.svg';
import Red from '../../images/svg/RedIcon.svg';
import Blue from '../../images/svg/BlueIcon.svg';
import OtherColor from '../../images/svg/OtherIcon.svg';
import * as UTIL from "../../util";
import NumberFormat from "react-number-format";
import PegModule from "../loyalty/PegModule"; // PayPal

import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";
import { paypalApprove, paypalCancel, paypalCreate } from './CheckoutHelpers/PayPal';
import { apiUtil, payPalClientId, tokenExIframeUrl, tokenExID } from '../../util/apiUtil';
import { TokenExPaymentForm } from './tokenex/tokenexiframe';
import { isValidPaymentData, GlobalStateProvider, GlobalStateContext } from './tokenex/InMemoryState';
import Modal from '../modal/Modal';
import moment from "moment";
import { debounce } from "lodash"; //ga tracker

import { gaDefault, gaTracker } from '../../util/ga-analytics/gaTracker';
import { checkoutStep } from '../../util/ga-analytics';
import CreditCardForm from "./CheckoutHelpers/CreditCardForm/CreditCardForm";
import CheckoutPayment from "./CheckoutHelpers/CheckoutPayment/CheckoutPayment";
import { useSelector } from "react-redux";
import SolidModal from "../modal/SolidModal";
import ImageLoader from '../images/ImageLoader';
import { GooglePayComponent } from './CheckoutHelpers/CheckoutPayment/GooglePay';
import { ApplePayComponent } from './CheckoutHelpers/CheckoutPayment/ApplePay';
var tipAmt = [15, 18, 20];
export var Summary = function Summary(props) {
  var _props$fullCart3, _props$fullCart3$pric, _props$fullCart4, _props$fullCart4$pric, _props$fullCart5;

  var _props$cost = props.cost,
      cost = _props$cost === void 0 ? {
    Total: 1
  } : _props$cost,
      placeDisabled = props.placeDisabled,
      _props$setTip = props.setTip,
      setTip = _props$setTip === void 0 ? function () {
    return console.log(summarySetTip);
  } : _props$setTip,
      _props$giftCardInfo = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo === void 0 ? [] : _props$giftCardInfo,
      isCatering = props.isCatering,
      isFood = props.isFood,
      isRetail = props.isRetail,
      isPaypal = props.isPaypal,
      _props$payPalSubmit = props.payPalSubmit,
      payPalSubmit = _props$payPalSubmit === void 0 ? function () {
    return console.log("Missing paypal submission");
  } : _props$payPalSubmit,
      _props$cart = props.cart,
      cart = _props$cart === void 0 ? [] : _props$cart,
      isSubmittingCart = props.isSubmittingCart,
      isPostingTip = props.isPostingTip,
      isValidatingOrder = props.isValidatingOrder,
      isSendingPromoCode = props.isSendingPromoCode,
      validateSuccess = props.validateSuccess,
      err = props.err,
      _props$isOfflineStore = props.isOfflineStore,
      isOfflineStore = _props$isOfflineStore === void 0 ? false : _props$isOfflineStore,
      fields = props.fields,
      store = props.store,
      loyaltyID = props.loyaltyID,
      loyaltyEmail = props.loyaltyEmail,
      _props$setPostLoyalty = props.setPostLoyaltyData,
      setPostLoyaltyData = _props$setPostLoyalty === void 0 ? function () {
    return console.log("setting PostLoyaltyData");
  } : _props$setPostLoyalty,
      isSubmitting = props.isSubmitting,
      validateForm = props.validateForm,
      submitForm = props.submitForm,
      setFieldTouched = props.setFieldTouched,
      AUTHSTATE = props.AUTHSTATE,
      values = props.values,
      paymentType = props.paymentType;

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      tipSelection = _useState2[0],
      setTipSelection = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      otherTip = _useState4[0],
      setOtherTip = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      otherTipSelected = _useState6[0],
      setOtherTipSelection = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      tipOptions = _useState8[0],
      setTipOptions = _useState8[1];

  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false; // const debouncer = debounce(setTipCall, 300, false);

  useEffect(function () {
    var options = [];
    tipAmt.map(function (percent) {
      var tips = {
        "percentage": percent + "%",
        "amount": (percent / 100 * cost.Subtotal).toFixed(2)
      };
      options.push(tips);
    });
    setTipOptions(options);
  }, [cost.Subtotal]);
  var debounceCallback = useCallback(debounce(function (amount, percent) {
    var data = {
      gtm: {
        uniqueEventId: '117',
        elementId: "checkout-tip-".concat(tipSelection),
        amount: amount,
        percent: percent
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    setTipCall(amount, percent);
  }, 500), []);
  useEffect(function () {
    if (tipSelection === -1) {
      return;
    }

    if (tipSelection === 3) {
      if (!isNaN(otherTip)) {
        debounceCallback(otherTip, 0);
      } else {
        debounceCallback(0, 0);
      }
    } else {
      setOtherTip(undefined);
      debounceCallback(0, tipAmt[tipSelection]);
    }
  }, [tipSelection, otherTip]);

  function setTipCall(amount, percent) {
    if (amount) {
      return setTip(parseFloat(amount), 0);
    } else {
      return setTip(0, percent);
    }
  }

  var placeOrderClick = function placeOrderClick(e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    checkoutStep({
      actionField: {
        'step': 4,
        'option': 'Place my order'
      },
      cartInfo: cart
    });
    var data = {
      gtm: {
        uniqueEventId: 126,
        elementId: 'placemyorder'
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var submitOrder = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var validations, validateCart;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e === null || e === void 0 ? void 0 : e.preventDefault();
              _context.prev = 1;
              _context.next = 4;
              return validateForm();

            case 4:
              validations = _context.sent;

              if (!(Object.keys(validations).length > 0)) {
                _context.next = 8;
                break;
              }

              Object.keys(validations).forEach(function (key) {
                props.setFieldTouched(key, true);
              });
              return _context.abrupt("return");

            case 8:
              _context.next = 10;
              return submitForm();

            case 10:
              validateCart = _context.sent;

              if (!validateCart) {
                _context.next = 14;
                break;
              }

              _context.next = 14;
              return props.handleSubmitCart(values);

            case 14:
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.error('Error Placing the Order: ', _context.t0.message);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16]]);
    }));

    return function submitOrder(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var rightToLeftFormatter = function rightToLeftFormatter(value) {
    if (!Number(value)) return '';
    var amount = '';

    if (amount.length > 2) {
      amount = parseInt(value).toFixed(2);
    } else {
      amount = (parseInt(value) / 100).toFixed(2);
    }

    return "".concat(amount);
  };

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _props$fullCart, _props$fullCart$price, _props$fullCart2, _props$fullCart2$save;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!(((_props$fullCart = props.fullCart) === null || _props$fullCart === void 0 ? void 0 : (_props$fullCart$price = _props$fullCart.price) === null || _props$fullCart$price === void 0 ? void 0 : _props$fullCart$price.Subtotal) && !props.removeTipAndEntitlementsState)) {
                _context2.next = 5;
                break;
              }

              _context2.next = 4;
              return props.removeTipAndEntitlements([]);

            case 4:
              if (!props.fullCart.price.GiftCardTotal > 0 && !props.fullCart.price.OloTip > 0 && !((_props$fullCart2 = props.fullCart) === null || _props$fullCart2 === void 0 ? void 0 : (_props$fullCart2$save = _props$fullCart2.savedPromos) === null || _props$fullCart2$save === void 0 ? void 0 : _props$fullCart2$save.length)) {
                props.setRemoveTipAndEntitlementsState(true);
              }

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              console.log('Error removeTipAndEntitlements: ', _context2.t0.message);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }))();
  }, [(_props$fullCart3 = props.fullCart) === null || _props$fullCart3 === void 0 ? void 0 : (_props$fullCart3$pric = _props$fullCart3.price) === null || _props$fullCart3$pric === void 0 ? void 0 : _props$fullCart3$pric.GiftCardTotal, (_props$fullCart4 = props.fullCart) === null || _props$fullCart4 === void 0 ? void 0 : (_props$fullCart4$pric = _props$fullCart4.price) === null || _props$fullCart4$pric === void 0 ? void 0 : _props$fullCart4$pric.OloTip, (_props$fullCart5 = props.fullCart) === null || _props$fullCart5 === void 0 ? void 0 : _props$fullCart5.savedPromos]);
  useEffect(function () {
    window.localStorage.setItem('digitalWalletValues', JSON.stringify({
      values: values,
      total: props.cost.Total
    }, function (key, value) {
      // Include properties with undefined values
      return value !== undefined ? value : null;
    }));
  }, [values, props.cost.Total]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__summary cb-checkout__section-container"
  }, useNewRebrandStyles ? /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__h3 cb-checkout__header-text"
  }, "Summary") : /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 990
  }, /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__h3 cb-checkout__header-text"
  }, "Summary")), (isCatering || isFood) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__tip"
  }, /*#__PURE__*/React.createElement("span", null, "Don't forget to add a tip!")), /*#__PURE__*/React.createElement(ButtonGroup, {
    className: "cb-checkout__tip-group"
  }, Array.isArray(tipOptions) && tipOptions.map(function (tip, index) {
    return /*#__PURE__*/React.createElement(Button, {
      type: "button",
      key: "checkout-tip-".concat(index),
      id: "checkout-tip-".concat(index),
      className: "cb-button-primary-tip ".concat(index === tipSelection ? "is-active" : ""),
      onClick: function onClick() {
        return setTipSelection(index);
      }
    }, tip.percentage, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, '$' + tip.amount));
  }), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    id: "checkout-other-tip",
    className: "cb-button-primary-tip ".concat(otherTipSelected && (tipSelection === -1 || tipSelection === 3) ? "is-active" : ""),
    onClick: function onClick() {
      setOtherTipSelection(true);
      setTipSelection(3);
    }
  }, "Other", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "Add custom tip"))), otherTipSelected && /*#__PURE__*/React.createElement("div", {
    className: "other-tip-amount"
  }, /*#__PURE__*/React.createElement("span", {
    className: "checkout-tip-amount-label"
  }, "Enter tip amount:"), /*#__PURE__*/React.createElement(NumberFormat, {
    className: "checkout-tip-amount-input",
    value: otherTip || "",
    id: "checkout-tip-other-amount",
    placeholder: "0.00",
    step: "0.01",
    decimalSeparator: ".",
    decimalScale: 2,
    maxLength: 8,
    format: rightToLeftFormatter,
    onChange: function onChange(e) {
      return setOtherTip(e.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", null, props.removeTipAndEntitlementsState && /*#__PURE__*/React.createElement(Cost, _extends({}, props, {
    showSummary: false
  }, cost))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    className: "cb-checkout__doublecheck"
  }, "Make sure to double-check your order details!"), !isOfflineStore && /*#__PURE__*/React.createElement("p", {
    className: "cb-checkout__tnc"
  }, "By clicking the \"Place my order\" button, I agree to ", /*#__PURE__*/React.createElement("a", {
    href: "/legal",
    id: "tnc-checkout"
  }, "Terms and Conditions"), "."), !paymentType.includes('applePay') && !paymentType.includes('googlePay') && /*#__PURE__*/React.createElement(StateButton, {
    disabled: isPostingTip || isValidatingOrder || isSendingPromoCode || isSubmitting,
    type: "button",
    className: "cb-button-primary d-block m-auto cb-checkout__placemyorder-btn",
    id: "placemyorder",
    loading: isSubmittingCart || isPostingTip || isValidatingOrder || isSendingPromoCode || isSubmitting,
    onClick: function onClick(e) {
      placeOrderClick(e);
      submitOrder(e);
    }
  }, "Place my order"), (isValidatingOrder || isPostingTip) && (paymentType.includes('googlePay') || paymentType.includes('applePay')) && /*#__PURE__*/React.createElement(StateButton, {
    disabled: true,
    type: "button",
    className: "cb-button-primary d-block m-auto cb-checkout__placemyorder-btn",
    id: "placemyorder",
    loading: true
  }, "Place my order"), paymentType.includes('googlePay') && !isValidatingOrder && !isPostingTip && /*#__PURE__*/React.createElement(GooglePayComponent, {
    handleSubmitCart: props.handleSubmitCart,
    submitForm: submitForm,
    validateForm: validateForm,
    placeOrderClick: placeOrderClick,
    setFieldTouched: setFieldTouched
  }), paymentType.includes('applePay') && !isValidatingOrder && !isPostingTip && /*#__PURE__*/React.createElement(ApplePayComponent, {
    handleSubmitCart: props.handleSubmitCart,
    submitForm: submitForm,
    validateForm: validateForm,
    placeOrderClick: placeOrderClick,
    setFieldTouched: setFieldTouched
  }))), AUTHSTATE && /*#__PURE__*/React.createElement("div", {
    className: "solid-modal--review__peg"
  }, /*#__PURE__*/React.createElement(PegModule, {
    isCheckout: true,
    store: props.store,
    authenticationState: props.authenticationState,
    fields: (fields === null || fields === void 0 ? void 0 : fields.PegModule) && fields.PegModule.length >= 1 ? fields.PegModule[0].fields : {}
  })));
};
export var SectionBanner = function SectionBanner(_ref3) {
  var _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? "" : _ref3$value,
      index = _ref3.index,
      activeCategoryIndex = _ref3.activeCategoryIndex,
      _ref3$defaultActive = _ref3.defaultActive,
      defaultActive = _ref3$defaultActive === void 0 ? false : _ref3$defaultActive,
      children = _ref3.children,
      _ref3$showNumber = _ref3.showNumber,
      showNumber = _ref3$showNumber === void 0 ? false : _ref3$showNumber;
  return /*#__PURE__*/React.createElement("h3", {
    className: "cb-checkout__section-banner"
  }, (showNumber ? index + 1 + ". " : "") + value, children);
};
export var AuthenticatedPersonalInfo = function AuthenticatedPersonalInfo(values, clickHandler, props) {
  var isRetail = props.isRetail,
      isFood = props.isFood,
      isCatering = props.isCatering;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: "cb-l-margin-xsmall--bottom cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RadioButton, {
    name: "personalInfoCheck",
    value: "yes",
    checked: true,
    className: "cb-type-body-sm pt-12",
    labelClass: "is-active"
  }, /*#__PURE__*/React.createElement("span", null, values.firstName, " ", values.lastName, /*#__PURE__*/React.createElement("br", null), values.email)), /*#__PURE__*/React.createElement(Field, {
    value: values.firstName,
    type: "hidden",
    name: "firstName"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.lastName,
    type: "hidden",
    name: "lastName"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.email,
    type: "hidden",
    name: "email"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.phone,
    type: "hidden",
    name: "phone"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      return clickHandler(true);
    }
  }, "Add different Contact Info.")))));
};
export var ExternalPayment = function ExternalPayment(props) {
  var cost = props.cost,
      deliveryMode = props.deliveryMode,
      deliveryMethod = props.deliveryMethod,
      setFieldValue = props.setFieldValue,
      setIsPaypal = props.setIsPaypal,
      setPaypalOrder = props.setPaypalOrder,
      setPayPalDetails = props.setPayPalDetails,
      requestPaypalOrder = props.requestPaypalOrder,
      resetPaypalOrder = props.resetPaypalOrder,
      setExternalPayment = props.setExternalPayment,
      externalPayment = props.externalPayment,
      setPaymentType = props.setPaymentType,
      isRetail = props.isRetail,
      isFood = props.isFood,
      isCatering = props.isCatering;

  var _useState9 = useState(cost),
      _useState10 = _slicedToArray(_useState9, 2),
      storedCost = _useState10[0],
      setStoredCost = _useState10[1];

  var _useState11 = useState(deliveryMode),
      _useState12 = _slicedToArray(_useState11, 2),
      storedDelivery = _useState12[0],
      setSotredDelivery = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      paypalLoaded = _useState14[0],
      setPaypalLoaded = _useState14[1];

  useEffect(function () {
    setStoredCost(cost);
    setSotredDelivery(deliveryMode);
  }, [cost, deliveryMode]);
  return /*#__PURE__*/React.createElement("div", {
    id: "cb-external-payment"
  }, !isRetail && !isFood && !isCatering && /*#__PURE__*/React.createElement("div", {
    className: "cb-l-margin-xxsmall--bottom"
  }, /*#__PURE__*/React.createElement(PayPalScriptProvider, {
    options: {
      "client-id": payPalClientId,
      "intent": "authorize",
      "commit": false,
      "debug": false
    }
  }, !paypalLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PayPalButtons, {
    fundingSource: FUNDING.PAYPAL,
    onButtonReady: function onButtonReady() {
      setPaypalLoaded(true);
    },
    createOrder: function createOrder(data, actions) {
      return paypalCreate(_objectSpread(_objectSpread({
        data: data,
        actions: actions
      }, props), {}, {
        cost: cost,
        deliveryMethod: deliveryMethod,
        requestPaypalOrder: requestPaypalOrder
      }));
    },
    onCancel: function onCancel() {
      return paypalCancel({
        resetPaypalOrder: resetPaypalOrder
      });
    },
    onApprove: function onApprove(data, actions) {
      return paypalApprove(_objectSpread(_objectSpread({
        cart: false,
        data: data,
        actions: actions
      }, props), {}, {
        cost: cost,
        deliveryMethod: deliveryMethod,
        setFieldValue: setFieldValue,
        setIsPaypal: setIsPaypal,
        cb: function cb(payPalDetails) {
          var payPalinfo = payPalDetails.payPalinfo;
          setPaypalOrder(payPalinfo);
          setPayPalDetails(payPalDetails);
          setExternalPayment(true);
          setPaymentType('paypal');
          Object.keys(payPalinfo).forEach(function (key) {
            setFieldValue(key, payPalinfo[key]);
          });
        }
      }));
    }
  })) : /*#__PURE__*/React.createElement("p", null))));
};
export var LocationInfo = function LocationInfo(_ref4) {
  var alternate_name = _ref4.alternate_name,
      alternateName = _ref4.alternateName,
      _ref4$storeaddress = _ref4.storeaddress;
  _ref4$storeaddress = _ref4$storeaddress === void 0 ? {} : _ref4$storeaddress;
  var value = _ref4$storeaddress.value,
      address1 = _ref4.address1,
      phone = _ref4.phone,
      state = _ref4.state,
      zip = _ref4.zip,
      city = _ref4.city;
  return Boolean(alternate_name || alternateName) && /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__location"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-cart__order-from-header"
  }, "Ordering from: ", alternate_name || alternateName), "jx", Boolean(value || address1) && /*#__PURE__*/React.createElement("div", null, value || address1), Boolean(city) && /*#__PURE__*/React.createElement("div", null, city, ", ", state, ", ", zip), Boolean(phone) && /*#__PURE__*/React.createElement("a", {
    href: "tel:" + phone
  }, phone));
};
export var PersonalInfo = function PersonalInfo(props) {
  var changeHandler = props.changeHandler,
      index = props.index,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive = props.defaultActive,
      defaultActive = _props$defaultActive === void 0 ? false : _props$defaultActive,
      children = props.children,
      values = props.values,
      setFieldValue = props.setFieldValue,
      propAuth = props.authenticationState,
      accountInfoModified = props.accountInfoModified,
      className = props.className,
      setExternalPayment = props.setExternalPayment,
      externalPayment = props.externalPayment,
      isRetail = props.isRetail,
      isFood = props.isFood,
      isCatering = props.isCatering,
      _props$isOfflineStore2 = props.isOfflineStore,
      isOfflineStore = _props$isOfflineStore2 === void 0 ? false : _props$isOfflineStore2;
  var AUTHSTATE = props.authenticationState === AuthenticationState.Authenticated;
  var firstName = values.firstName,
      lastName = values.lastName,
      email = values.email,
      phone = values.phone,
      smscheck = values.smscheck,
      _values$newsLetterEma = values.newsLetterEmailSignUp,
      newsLetterEmailSignUp = _values$newsLetterEma === void 0 ? true : _values$newsLetterEma;
  var isAuthenticated = AUTHSTATE ? false : true;

  var checkInfo = function checkInfo() {
    var info = typeof values.firstName !== 'undefined' && typeof values.lastName !== 'undefined' && typeof values.email !== 'undefined' && typeof values.phone !== 'undefined';
    return info;
  };

  var _useState15 = useState(checkInfo()),
      _useState16 = _slicedToArray(_useState15, 2),
      infoExists = _useState16[0],
      setInfoExists = _useState16[1];

  var _useState17 = useState(isAuthenticated || infoExists),
      _useState18 = _slicedToArray(_useState17, 2),
      showPersonalForm = _useState18[0],
      setShowPersonalForm = _useState18[1];

  useEffect(function () {
    if (showPersonalForm) {
      cleanup();
    }
  }, [showPersonalForm]);
  useEffect(function () {
    setFieldValue('newsLetterEmailSignUp', newsLetterEmailSignUp);
  }, []);
  useEffect(function () {
    var info = checkInfo();
    setInfoExists(info);
  }, [accountInfoModified]);

  var cleanup = function cleanup() {// setFieldValue("firstName", undefined)
    // setFieldValue("lastName", undefined)
    // setFieldValue("email", undefined)
    // setFieldValue("phone", undefined)
  };

  var section = function section() {
    var infoExists = checkInfo();

    if (AUTHSTATE && !showPersonalForm && infoExists) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, AuthenticatedPersonalInfo(values, setShowPersonalForm, props));
    } else {
      var _props$deliveryMethod, _props$deliveryMethod2;

      return /*#__PURE__*/React.createElement(React.Fragment, null, !AUTHSTATE && /*#__PURE__*/React.createElement("p", null, "As a guest, we need to get some info from you"), AUTHSTATE && !infoExists && /*#__PURE__*/React.createElement("p", null, "Looks like we are missing some of your info"), /*#__PURE__*/React.createElement("div", {
        className: "mt-16"
      }, /*#__PURE__*/React.createElement(Field, {
        value: firstName,
        name: "firstName",
        label: "First Name",
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: changeHandler
      }), /*#__PURE__*/React.createElement(Field, {
        value: lastName,
        name: "lastName",
        label: "Last Name",
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: changeHandler
      }), /*#__PURE__*/React.createElement(Field, {
        value: email,
        name: "email",
        label: "Email Address",
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: changeHandler
      }), /*#__PURE__*/React.createElement(Field, {
        value: phone,
        name: "phone",
        label: "Mobile Number",
        type: "tel",
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: changeHandler
      }), isFood && !isCatering && ((_props$deliveryMethod = props.deliveryMethod) === null || _props$deliveryMethod === void 0 ? void 0 : _props$deliveryMethod.foodDeliveryMode) == 'curbside' || isCatering && !isFood && ((_props$deliveryMethod2 = props.deliveryMethod) === null || _props$deliveryMethod2 === void 0 ? void 0 : _props$deliveryMethod2.caterDeliveryMode) == 'curbside' ? /*#__PURE__*/React.createElement(Field, {
        value: false,
        type: "checkbox",
        name: "smscheck",
        label: /*#__PURE__*/React.createElement("div", {
          class: "smslabel",
          onClick: function onClick(e) {
            e.currentTarget.previousElementSibling.querySelector('input').click();
          }
        }, /*#__PURE__*/React.createElement("label", {
          for: "smscheck"
        }, "Get SMS texts for your Curbside order"), /*#__PURE__*/React.createElement("label", {
          for: "smscheck"
        }, "SMS consent is not required to make a purchase. Msg&Data rates may apply."), /*#__PURE__*/React.createElement("label", {
          for: "smscheck-sub"
        }, "4msgs/mo. Wireless Carriers are not liable for delayed or undelivered messages. Text HELP for help and STOP to cancel. View our ", /*#__PURE__*/React.createElement("a", {
          href: "https://www.crackerbarrel.com/sms",
          target: "_blank"
        }, "Terms and Conditions"), " or ", /*#__PURE__*/React.createElement("a", {
          href: "https://www.crackerbarrel.com/Legal",
          target: "_blank"
        }, "Privacy"), ".")),
        component: FormCheckbox,
        checked: smscheck,
        onClick: function onClick() {
          return props.setFieldValue('smscheck', !smscheck);
        }
      }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Field, {
        value: true,
        checked: newsLetterEmailSignUp,
        type: "checkbox",
        name: "newsLetterEmailSignUp",
        label: "Sign up for emails to never miss an update.",
        component: FormCheckbox,
        changeHandler: function changeHandler(e) {
          return setFieldValue('newsLetterEmailSignUp', !newsLetterEmailSignUp);
        }
      })));
    }
  };

  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: defaultActive,
    value: "Contact Info"
  }), /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, section())), children));
};
export var AuthenticatedPickupInfo = function AuthenticatedPickupInfo(values, clickHandler) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, "We will send you an email when your order is ready.  A valid government ID such as a driver's license is needed at pickup"))), /*#__PURE__*/React.createElement(Row, {
    className: "cb-l-margin-xsmall--bottom"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RadioButton, {
    name: "pickupInfoCheck",
    value: "yes",
    checked: true,
    className: "cb-type-body-sm pt-12",
    labelClass: "is-active"
  }, /*#__PURE__*/React.createElement("span", null, values.firstName, " ", values.lastName, /*#__PURE__*/React.createElement("br", null), values.email)), /*#__PURE__*/React.createElement(Field, {
    value: values.firstName,
    type: "hidden",
    name: "pickupFirst"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.lastName,
    type: "hidden",
    name: "pickupLast"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.email,
    type: "hidden",
    name: "pickupEmail"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      return clickHandler(true);
    }
  }, "Add different pickup person.")))));
};
export var PickupInfoForm = function PickupInfoForm(props) {
  var changeHandler = props.changeHandler,
      values = props.values;
  return /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, "We will send you an email when your order is ready.  A valid government ID such as a driver's license is needed at pickup"), /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Field, {
    value: values.firstName,
    name: "pickupFirst",
    label: "First Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: changeHandler
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.lastName,
    name: "pickupLast",
    label: "Last Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: changeHandler
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.email,
    name: "pickupEmail",
    label: "Email Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: changeHandler
  })))));
};
export var PickupInfo = function PickupInfo(props) {
  var _props$index = props.index,
      index = _props$index === void 0 ? 1 : _props$index,
      activeCategoryIndex = props.activeCategoryIndex,
      children = props.children,
      values = props.values,
      AUTHSTATE = props.AUTHSTATE;
  var isActive = index === activeCategoryIndex;
  var isPast = index <= activeCategoryIndex;
  var isAuthenticated = AUTHSTATE ? false : true;

  var _useState19 = useState(isAuthenticated),
      _useState20 = _slicedToArray(_useState19, 2),
      showPickupForm = _useState20[0],
      setShowPickupForm = _useState20[1];

  var section = function section() {
    var infoExists = typeof values.firstName !== 'undefined' && typeof values.lastName !== 'undefined' && typeof values.email !== 'undefined';

    if (AUTHSTATE && !showPickupForm && infoExists) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, (isActive || isPast) && AuthenticatedPickupInfo(values, setShowPickupForm));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, (isActive || isPast) && /*#__PURE__*/React.createElement(PickupInfoForm, {
        values: values,
        isActive: index === activeCategoryIndex
      }));
    }
  };

  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex
  }, "Order Pickup information"), section(), children);
};
export var DeliveryMethod = function DeliveryMethod(props) {
  var _handleDeliveryDispla, _handleDeliveryDispla2;

  var _props$cart2 = props.cart,
      cart = _props$cart2 === void 0 ? {} : _props$cart2,
      index = props.index,
      children = props.children,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive2 = props.defaultActive,
      defaultActive = _props$defaultActive2 === void 0 ? false : _props$defaultActive2,
      _props$deliveryMethod3 = props.deliveryMethod,
      deliveryMethod = _props$deliveryMethod3 === void 0 ? {} : _props$deliveryMethod3,
      setFieldValue = props.setFieldValue,
      _props$location = props.location,
      location = _props$location === void 0 ? {} : _props$location,
      _props$destructuredCa = props.destructuredCart,
      destructuredCart = _props$destructuredCa === void 0 ? {} : _props$destructuredCa,
      shippingMode = props.shippingMode;
  var isActive = index === activeCategoryIndex || defaultActive;
  var isPast = index <= activeCategoryIndex;
  var foodMethod = deliveryMethod.foodDeliveryMode;
  var caterMethod = deliveryMethod.caterDeliveryMode;
  var retailMethod = deliveryMethod.retailDeliveryMode || shippingMode;
  var _destructuredCart$foo = destructuredCart.foodItems,
      foodItems = _destructuredCart$foo === void 0 ? [] : _destructuredCart$foo,
      _destructuredCart$cat = destructuredCart.caterItems,
      caterItems = _destructuredCart$cat === void 0 ? [] : _destructuredCart$cat,
      _destructuredCart$ret = destructuredCart.retailItems,
      retailItems = _destructuredCart$ret === void 0 ? [] : _destructuredCart$ret;

  var handleDeliveryDisplay = function handleDeliveryDisplay(method) {
    return (method === null || method === void 0 ? void 0 : method.toLowerCase()) === "dispatch" ? "delivery" : method;
  };

  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: defaultActive,
    value: "Delivery Method"
  }), (isActive || isPast) && /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    isCheckout: true,
    items: foodItems,
    title: "Food - ".concat((_handleDeliveryDispla = handleDeliveryDisplay(foodMethod)) !== null && _handleDeliveryDispla !== void 0 ? _handleDeliveryDispla : "")
  })), /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    isCheckout: true,
    items: caterItems,
    title: "Cater - ".concat((_handleDeliveryDispla2 = handleDeliveryDisplay(caterMethod)) !== null && _handleDeliveryDispla2 !== void 0 ? _handleDeliveryDispla2 : "")
  })), /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    isCheckout: true,
    items: retailItems,
    title: "Shop - ".concat(retailMethod)
  })), children));
}; // Shipping Info

export var AuthenticatedAddressInfo = function AuthenticatedAddressInfo(values, clickHandler) {
  if ((values === null || values === void 0 ? void 0 : values.shippingStreetAddress) == "" || (values === null || values === void 0 ? void 0 : values.shippingStreetAddress) == undefined || (values === null || values === void 0 ? void 0 : values.shippingStreetAddress) == null) {
    clickHandler(true);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "cb-l-margin-xsmall--bottom"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RadioButton, {
    name: "shippingInfoCheck",
    value: "yes",
    checked: true,
    className: "cb-type-body-sm pt-12",
    labelClass: "is-active"
  }, /*#__PURE__*/React.createElement("span", null, values.shippingStreetAddress, " ", values.shippingStreetAddress2, " ", values.shippingCity, ", ", values.shippingState, " ", values.shippingZip))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.shippingStreetAddress,
    type: "hidden",
    name: "shippingStreetAddress"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.shippingStreetAddress2,
    type: "hidden",
    name: "shippingStreetAddress2"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.shippingCity,
    type: "hidden",
    name: "shippingCity"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.shippingState,
    type: "hidden",
    name: "shippingState"
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.shippingZip,
    type: "hidden",
    name: "shippingZip"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      return clickHandler(true);
    }
  }, "Add a different address.")))));
};
export var AddressInfo = function AddressInfo(props) {
  var _deliveryMethod$retai;

  var _props$index2 = props.index,
      index = _props$index2 === void 0 ? 1 : _props$index2,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive3 = props.defaultActive,
      defaultActive = _props$defaultActive3 === void 0 ? false : _props$defaultActive3,
      children = props.children,
      setFieldValue = props.setFieldValue,
      values = props.values,
      _props$deliveryMethod4 = props.deliveryMethod,
      deliveryMethod = _props$deliveryMethod4 === void 0 ? {} : _props$deliveryMethod4,
      AKHIcheck = props.AKHIcheck,
      _props$saveDeliveryMo = props.saveDeliveryMode,
      saveDeliveryMode = _props$saveDeliveryMo === void 0 ? function () {
    return "";
  } : _props$saveDeliveryMo,
      propAuth = props.authenticationState,
      accountInfoModified = props.accountInfoModified,
      AUTHSTATE = props.AUTHSTATE,
      _props$showRetail = props.showRetail,
      showRetail = _props$showRetail === void 0 ? false : _props$showRetail,
      className = props.className,
      addressValidation = props.addressValidation,
      isRetail = props.isRetail,
      addressDisable = props.addressDisable;
  var isActive = index === activeCategoryIndex || defaultActive;
  var isPast = index <= activeCategoryIndex;

  var checkInfo = function checkInfo() {
    var info = typeof values["".concat(addressType, "StreetAddress")] !== 'undefined' && typeof values["".concat(addressType, "City")] !== 'undefined' && typeof values["".concat(addressType, "State")] !== 'undefined' && typeof values["".concat(addressType, "Zip")] !== 'undefined';
    return info;
  };

  var addressType = showRetail ? "retail" : "shipping";
  var isAuthenticated = AUTHSTATE ? false : true;

  var _useState21 = useState(checkInfo()),
      _useState22 = _slicedToArray(_useState21, 2),
      infoExists = _useState22[0],
      setInfoExists = _useState22[1];

  var _useState23 = useState(isAuthenticated || infoExists),
      _useState24 = _slicedToArray(_useState23, 2),
      showShippingForm = _useState24[0],
      setShowShippingForm = _useState24[1];

  useEffect(function () {
    if (showShippingForm) {
      cleanup();
    }
  }, [showShippingForm]);
  useEffect(function () {
    var info = checkInfo();
    setInfoExists(info);
  }, [accountInfoModified]);

  var cleanup = function cleanup() {// setFieldValue(`${addressType}StreetAddress`, "")
    // setFieldValue(`${addressType}City`, "")
    // setFieldValue(`${addressType}State`, "")
    // setFieldValue(`${addressType}Zip`, "")
  };

  var section = function section() {
    if (!showShippingForm) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, AuthenticatedAddressInfo(values, setShowShippingForm));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Field, {
        value: values["".concat(addressType, "StreetAddress")],
        name: "".concat(addressType, "StreetAddress"),
        label: "Address",
        disabled: addressDisable,
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: function changeHandler(e) {
          return setFieldValue("".concat(addressType, "StreetAddress"), e);
        }
      }), /*#__PURE__*/React.createElement(Field, {
        value: values["".concat(addressType, "StreetAddress2")],
        name: "".concat(addressType, "StreetAddress2"),
        label: "Building Name / Suite / Apt",
        disabled: addressDisable,
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: function changeHandler(e) {
          return setFieldValue("".concat(addressType, "StreetAddress2"), e);
        }
      }), /*#__PURE__*/React.createElement(Field, {
        value: values["".concat(addressType, "City")],
        name: "".concat(addressType, "City"),
        label: "City",
        disabled: addressDisable,
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: function changeHandler(e) {
          return setFieldValue("".concat(addressType, "City"), e);
        }
      }), /*#__PURE__*/React.createElement(Field, {
        value: values["".concat(addressType, "State")],
        name: "".concat(addressType, "State"),
        label: "State",
        disabled: addressDisable,
        hideLabel: true,
        component: FormSelect,
        options: UsStates,
        className: "cb-form__input--full",
        changeHandler: function changeHandler(e) {
          return setFieldValue("".concat(addressType, "State"), e.currentTarget.value);
        }
      }), /*#__PURE__*/React.createElement(Field, {
        value: values["".concat(addressType, "Zip")],
        name: "".concat(addressType, "Zip"),
        label: "Postal Code",
        disabled: addressDisable,
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: function changeHandler(e) {
          return setFieldValue("".concat(addressType, "Zip"), e);
        }
      }), /*#__PURE__*/React.createElement(Field, {
        value: values["".concat(addressType, "Other")],
        name: "".concat(addressType, "Other"),
        label: "Other Instructions",
        disabled: addressDisable,
        component: FormControlledInput,
        className: "cb-form__input--full",
        changeHandler: function changeHandler(e) {
          return setFieldValue("".concat(addressType, "Other"), e);
        }
      }), AUTHSTATE ? /*#__PURE__*/React.createElement(Field, {
        value: "true",
        type: "checkbox",
        name: "saveDeliveryAddress",
        label: "Save to my account",
        component: FormCheckbox,
        changeHandler: function changeHandler(e) {
          return setFieldValue('saveDeliveryAddress', !values.saveDeliveryAddress);
        }
      }) : null);
    }
  };

  var updated = _objectSpread({}, deliveryMethod);

  updated.retailDeliveryMode = isRetail && (deliveryMethod === null || deliveryMethod === void 0 ? void 0 : (_deliveryMethod$retai = deliveryMethod.retailDeliveryMode) === null || _deliveryMethod$retai === void 0 ? void 0 : _deliveryMethod$retai.includes("standard")) ? "standard - alaska and hawaii" : "expedited - alaska and hawaii";
  var label = showRetail ? "Shipping address" : "Delivery address";
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: defaultActive
  }, label), (isActive || isPast) && /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, section(), AKHIcheck && /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__AKHI"
  }, /*#__PURE__*/React.createElement("p", null, "Alaska/Hawaii requires alternative shipping, different rates apply"), /*#__PURE__*/React.createElement("button", {
    className: "cb-button-secondary",
    onClick: function onClick() {
      return saveDeliveryMode(updated);
    }
  }, "Accept")))), children));
}; // Payment Info

export var PaymentInfo = function PaymentInfo(props) {
  var _props$index3 = props.index,
      index = _props$index3 === void 0 ? 1 : _props$index3,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive4 = props.defaultActive,
      defaultActive = _props$defaultActive4 === void 0 ? false : _props$defaultActive4,
      children = props.children,
      changeHandler = props.changeHandler,
      _props$setFieldValue = props.setFieldValue,
      setFieldValue = _props$setFieldValue === void 0 ? function () {
    return "fieldValue";
  } : _props$setFieldValue,
      _props$errors = props.errors,
      errors = _props$errors === void 0 ? {} : _props$errors,
      _props$setFieldTouche = props.setFieldTouched,
      setFieldTouched = _props$setFieldTouche === void 0 ? function () {
    return console.log("FIELDTOUCHED");
  } : _props$setFieldTouche,
      values = props.values,
      showGiftCard = props.showGiftCard,
      _props$giftCardInfo2 = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo2 === void 0 ? [] : _props$giftCardInfo2,
      _props$removeGiftCard = props.removeGiftCard,
      removeGiftCard = _props$removeGiftCard === void 0 ? function () {
    return "";
  } : _props$removeGiftCard,
      _props$getGiftCardSch = props.getGiftCardSchema,
      getGiftCardSchema = _props$getGiftCardSch === void 0 ? function () {
    return "";
  } : _props$getGiftCardSch,
      _props$creditCardInfo = props.creditCardInfo,
      creditCardInfo = _props$creditCardInfo === void 0 ? {} : _props$creditCardInfo,
      _props$getCreditCardS = props.getCreditCardSchema,
      getCreditCardSchema = _props$getCreditCardS === void 0 ? function () {
    return "";
  } : _props$getCreditCardS,
      _props$functionName = props.functionName,
      functionName = _props$functionName === void 0 ? function () {
    return "";
  } : _props$functionName,
      isFood = props.isFood,
      isCatering = props.isCatering,
      isRetail = props.isRetail,
      err = props.err,
      isError = props.isError,
      isPaypal = props.isPaypal,
      setExternalPayment = props.setExternalPayment,
      externalPayment = props.externalPayment,
      cost = props.cost,
      _props$isOfflineStore3 = props.isOfflineStore,
      isOfflineStore = _props$isOfflineStore3 === void 0 ? false : _props$isOfflineStore3,
      _props$dontGetGiftCar = props.dontGetGiftCardSchema,
      dontGetGiftCardSchema = _props$dontGetGiftCar === void 0 ? false : _props$dontGetGiftCar,
      getTokenExAuthToken = props.getTokenExAuthToken,
      isTokenExEnabled = props.isTokenExEnabled;
  var defaultsetting = "creditcard"; // const {paymentMethod:paymentType}=values;

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      showCheckbox = _useState26[0],
      setCheckbox = _useState26[1];

  var handleContinue = function handleContinue(index, fields) {
    var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return console.log("handleContinue");
    };
    var invalid;
    fields.forEach(function (field) {
      setFieldTouched(field, true);

      if (Boolean(errors[field])) {
        invalid = true;
      }
    });

    if (!invalid) {
      return func(index);
    } else {
      return false;
    }
  };

  var isActive = index === activeCategoryIndex || defaultActive;
  var isPast = index <= activeCategoryIndex;

  var changeHandlerCustom = function changeHandlerCustom(e, type) {
    e.persist();
    setPaymentType(e.target.value);
    setFieldValue("paymentMethod", e.target.value);
  };

  useEffect(function () {
    if (!dontGetGiftCardSchema) getGiftCardSchema();
    getCreditCardSchema();
  }, []);

  var handleCheckboxChange = function handleCheckboxChange() {
    var updatedCheckbox = !showCheckbox;
    return setCheckbox(updatedCheckbox);
  };

  return /*#__PURE__*/React.createElement(GlobalStateProvider, null, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: defaultActive
  }, "Payment"), (isActive || isPast) && /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(React.Fragment, null, cost.Total !== cost.Used && /*#__PURE__*/React.createElement(CreditCardInfo, _extends({
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    setFieldTouched: setFieldTouched
  }, props), children), cost.Total === cost.Used && /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__button-wrapper"
  }, activeCategoryIndex === index && /*#__PURE__*/React.createElement(StateButton, {
    type: "button",
    className: "cb-button-primary",
    onClick: function onClick() {
      functionName(index + 1, []);
    }
  }, "Save & Continue")))))), children));
};
export var BillingAddress = function BillingAddress(props) {
  var _props$index4 = props.index,
      index = _props$index4 === void 0 ? 1 : _props$index4,
      activeCategoryIndex = props.activeCategoryIndex,
      children = props.children,
      changeHandler = props.changeHandler,
      _props$setFieldValue2 = props.setFieldValue,
      setFieldValue = _props$setFieldValue2 === void 0 ? function () {
    return "fieldValue";
  } : _props$setFieldValue2,
      _props$errors2 = props.errors,
      errors = _props$errors2 === void 0 ? {} : _props$errors2,
      _props$setFieldTouche2 = props.setFieldTouched,
      setFieldTouched = _props$setFieldTouche2 === void 0 ? function () {
    return console.log("FIELDTOUCHED");
  } : _props$setFieldTouche2,
      values = props.values,
      showGiftCard = props.showGiftCard,
      _props$giftCardInfo3 = props.giftCardInfo,
      giftCardInfo = _props$giftCardInfo3 === void 0 ? {} : _props$giftCardInfo3,
      _props$removeGiftCard2 = props.removeGiftCard,
      removeGiftCard = _props$removeGiftCard2 === void 0 ? function () {
    return "";
  } : _props$removeGiftCard2,
      _props$getGiftCardSch2 = props.getGiftCardSchema,
      getGiftCardSchema = _props$getGiftCardSch2 === void 0 ? function () {
    return "";
  } : _props$getGiftCardSch2,
      isRetail = props.isRetail,
      _props$creditCardInfo2 = props.creditCardInfo,
      creditCardInfo = _props$creditCardInfo2 === void 0 ? {} : _props$creditCardInfo2,
      _props$getCreditCardS2 = props.getCreditCardSchema,
      getCreditCardSchema = _props$getCreditCardS2 === void 0 ? function () {
    return "";
  } : _props$getCreditCardS2,
      AUTHSTATE = props.AUTHSTATE,
      _props$dontGetGiftCar2 = props.dontGetGiftCardSchema,
      dontGetGiftCardSchema = _props$dontGetGiftCar2 === void 0 ? false : _props$dontGetGiftCar2,
      isTokenExEnabled = props.isTokenExEnabled,
      fullCart = props.fullCart;
  if (fullCart.isTokenExEnabled) return null;
  var paymentType = values.paymentMethod;

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      showCheckbox = _useState28[0],
      setCheckbox = _useState28[1];

  var handleContinue = function handleContinue(index, fields) {
    var func = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
      return console.log("handleContinue");
    };
    var invalid;
    fields.forEach(function (field) {
      setFieldTouched(field, true);

      if (Boolean(errors[field])) {
        invalid = true;
      }
    });

    if (!invalid) {
      return func(index);
    } else {
      return false;
    }
  };

  var isActive = index === activeCategoryIndex;
  var isPast = index <= activeCategoryIndex;

  var changeHandlerCustom = function changeHandlerCustom(e, type) {
    e.persist();
    setPaymentType(e.target.value);
    setFieldValue("paymentMethod", e.target.value);
  };

  useEffect(function () {
    if (!dontGetGiftCardSchema) getGiftCardSchema();
    getCreditCardSchema();
  }, []);

  var handleCheckboxChange = function handleCheckboxChange() {
    var updatedCheckbox = !showCheckbox;
    return setCheckbox(updatedCheckbox);
  };

  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex
  }, "Billing Address"), (isActive || isPast) && /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(BillingInfo, _extends({}, props, {
    values: values
  }))))), children);
};

var CreditCardInfo = function CreditCardInfo(_ref5) {
  var _ref5$setFieldValue = _ref5.setFieldValue,
      setFieldValue = _ref5$setFieldValue === void 0 ? function () {
    return "";
  } : _ref5$setFieldValue,
      setPaymentType = _ref5.setPaymentType,
      paymentType = _ref5.paymentType,
      errors = _ref5.errors,
      isFood = _ref5.isFood,
      isCatering = _ref5.isCatering,
      values = _ref5.values,
      setFieldTouched = _ref5.setFieldTouched,
      validateHandler = _ref5.validateHandler;

  var _useContext = useContext(GlobalStateContext),
      setGlobalState = _useContext.setGlobalState;

  var handlePaymentChange = function handlePaymentChange(type) {
    setPaymentType(type);
    var paymentTypeAux = type.join(',');
    setFieldValue('paymentMethod', paymentTypeAux);
  };

  useEffect(function () {
    handlePaymentChange(['card']);
  }, []);
  return /*#__PURE__*/React.createElement(CheckoutPayment, {
    mixedCart: isFood && isCatering,
    errors: errors,
    setFieldValue: setFieldValue,
    setGlobalState: setGlobalState,
    paymentType: paymentType,
    setPaymentType: handlePaymentChange,
    values: values,
    setFieldTouched: setFieldTouched,
    validateHandler: validateHandler
  });
};

var BillingInfo = function BillingInfo(props) {
  var shippingInfo = props.shippingInfo,
      propChange = props.changeHandler,
      values = props.values,
      AUTHSTATE = props.AUTHSTATE,
      _props$addresses = props.addresses,
      addresses = _props$addresses === void 0 ? [] : _props$addresses,
      setFieldValue = props.setFieldValue;
  var infoObj = {
    streetAddress: values.shippingStreetAddress || values.retailStreetAddress,
    streetAddress2: values.shippingStreetAddress2 || values.retailStreetAddress2,
    city: values.shippingCity || values.retailCity,
    state: values.shippingState || values.retailState,
    zip: values.shippingZip || values.retailZip
  }; // Trim four digit zip for billing

  if (infoObj.zip) {
    infoObj.zip = infoObj.zip.split('-')[0];
  }

  var _useState29 = useState(!!Boolean(infoObj.streetAddress)),
      _useState30 = _slicedToArray(_useState29, 2),
      editShipping = _useState30[0],
      setEdit = _useState30[1];

  useEffect(function () {
    if (editShipping) {
      _changeHandler("billingStreetAddress", "".concat(infoObj.streetAddress).concat(infoObj.streetAddress2 ? ", " + infoObj.streetAddress2 : "")), _changeHandler("billingCity", infoObj.city);

      _changeHandler("billingState", infoObj.state);

      _changeHandler("billingZip", infoObj.zip);
    } else {
      _changeHandler("billingStreetAddress", ""), _changeHandler("billingCity", "");

      _changeHandler("billingState", "");

      _changeHandler("billingZip", "");
    }
  }, [editShipping]);

  var _changeHandler = function changeHandler(a, b) {
    setFieldValue(a, b);
  };

  return /*#__PURE__*/React.createElement("div", null, Boolean(infoObj.streetAddress) && /*#__PURE__*/React.createElement(FormGroup, {
    className: "cb-checkout__checkbox-group"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "",
    checked: editShipping,
    onClick: function onClick() {
      return setEdit(!editShipping);
    }
  }), (addresses === null || addresses === void 0 ? void 0 : addresses.length) === 0 && /*#__PURE__*/React.createElement("label", null, "Billing address same as Shipping"), AUTHSTATE && (addresses === null || addresses === void 0 ? void 0 : addresses.length) > 0 && /*#__PURE__*/React.createElement("label", null, "Use My Saved Billing Address")), !editShipping && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "Set your Billing address"), /*#__PURE__*/React.createElement(Field, {
    value: values.billingStreetAddress,
    name: "billingStreetAddress",
    label: "Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return _changeHandler("billingStreetAddress", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.billingCity,
    name: "billingCity",
    label: "City",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return _changeHandler("billingCity", e);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.billingState,
    name: "billingState",
    label: "State",
    hideLabel: true,
    component: FormSelect,
    options: UsStates,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return setFieldValue("billingState", e.currentTarget.value);
    }
  }), /*#__PURE__*/React.createElement(Field, {
    value: values.billingZip,
    name: "billingZip",
    label: "Postal Code",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: function changeHandler(e) {
      return _changeHandler("billingZip", e);
    }
  })), editShipping && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, values.firstName, " ", values.lastName), /*#__PURE__*/React.createElement("p", null, infoObj.streetAddress, " ", infoObj.streetAddress2), /*#__PURE__*/React.createElement("p", null, infoObj.city, ", ", infoObj.state, " ", infoObj.zip)));
};

export var ControlledInput = function ControlledInput(_ref6) {
  var value = _ref6.value,
      label = _ref6.label,
      onChange = _ref6.onChange,
      className = _ref6.className;
  return /*#__PURE__*/React.createElement(FormGroup, {
    className: className
  }, /*#__PURE__*/React.createElement("label", {
    className: "cb-form__label is-active"
  }, label), /*#__PURE__*/React.createElement("input", {
    value: value,
    onChange: onChange,
    className: "cb-form__input--full cb-form__input form-control"
  }));
};

var BottomLine = function BottomLine(_ref7) {
  var children = _ref7.children,
      hide = _ref7.hide;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(hide ? '' : 'cb-checkout__bottom-line')
  }, children);
};

export var CurbsideInfo = function CurbsideInfo(props) {
  var flags = useFlags();
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  var _props$index5 = props.index,
      index = _props$index5 === void 0 ? 3 : _props$index5,
      activeCategoryIndex = props.activeCategoryIndex,
      children = props.children,
      changeHandler = props.changeHandler,
      defaultActive = props.defaultActive,
      _props$vehicleListTyp = props.vehicleListTypes,
      vehicleListTypes = _props$vehicleListTyp === void 0 ? [{
    name: "Car",
    iconPath: useNewRebrandStyles ? CarIconRebrand : CarIcon
  }, {
    name: "Truck",
    iconPath: useNewRebrandStyles ? TruckIconRebrand : TruckIcon
  }, {
    name: "SUV",
    iconPath: useNewRebrandStyles ? SuvIconRebrand : SuvIcon
  }, {
    name: "Van",
    iconPath: useNewRebrandStyles ? VanIconRebrand : VanIcon
  }, {
    name: "Hatch-back",
    iconPath: useNewRebrandStyles ? HatchIconRebrand : HatchIcon
  }, {
    name: "Other",
    iconPath: useNewRebrandStyles ? OtherVehicleIconRebrand : OtherVehicleIcon
  }] : _props$vehicleListTyp,
      _props$vehicleListCol = props.vehicleListColors,
      vehicleListColors = _props$vehicleListCol === void 0 ? [{
    name: "White",
    iconPath: White
  }, {
    name: "Silver / Gray",
    iconPath: Silver
  }, {
    name: "Black",
    iconPath: Black
  }, {
    name: "Red",
    iconPath: Red
  }, {
    name: "Blue",
    iconPath: Blue
  }, {
    name: "Other",
    iconPath: OtherColor
  }] : _props$vehicleListCol;

  var _onchange = function onchange(data) {
    setValue(data);
  };

  var _useState31 = useState(''),
      _useState32 = _slicedToArray(_useState31, 2),
      value = _useState32[0],
      setValue = _useState32[1];

  activeCategoryIndex === index;
  return /*#__PURE__*/React.createElement("section", {
    className: "cb-checkout__curbside-info"
  }, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: defaultActive
  }, "Curbside Pick Up Info"), /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text",
    style: {
      fontWeight: "bold",
      paddingBottom: "10px"
    }
  }, "What vehicle are you picking up in?"), /*#__PURE__*/React.createElement(Field, {
    name: "curbsideMake",
    label: "Vehicle Make",
    component: FormInput,
    className: "cb-form__input--full",
    changeHandler: changeHandler
  }), /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text",
    style: {
      fontWeight: "bold",
      paddingBottom: "10px"
    }
  }, "Select your vehicle type"), /*#__PURE__*/React.createElement(VehicleMenu, {
    vehicleList: vehicleListTypes,
    onchange: function onchange(value) {
      _onchange(value), props.setFieldValue('curbsideModel', value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    level: "2",
    className: "cb-banner__text",
    style: {
      fontWeight: "bold",
      paddingBottom: "10px",
      paddingTop: "40px"
    }
  }, "Select your vehicle color"), /*#__PURE__*/React.createElement(VehicleMenu, {
    vehicleList: vehicleListColors,
    onchange: function onchange(value) {
      _onchange(value), props.setFieldValue('curbsideColor', value);
    }
  })))), children);
};

var Promo = function Promo(props) {
  var _props$postPromoCode = props.postPromoCode,
      postPromoCode = _props$postPromoCode === void 0 ? function (promo) {
    return console.log(promo, "postPromoCodeINcomponent");
  } : _props$postPromoCode,
      _props$deletePromoCod = props.deletePromoCode,
      deletePromoCode = _props$deletePromoCod === void 0 ? function (promo) {
    return console.log(promo, "deletePromoCodeIncomponen");
  } : _props$deletePromoCod,
      _props$savedPromos = props.savedPromos,
      savedPromos = _props$savedPromos === void 0 ? [] : _props$savedPromos,
      isSendingPromoCode = props.isSendingPromoCode,
      validateSuccess = props.validateSuccess,
      isSubmittingCart = props.isSubmittingCart;

  var _useState33 = useState(""),
      _useState34 = _slicedToArray(_useState33, 2),
      promoType = _useState34[0],
      setPromoType = _useState34[1];

  var promoHandler = function promoHandler() {
    var newPromo = promoType;

    if (newPromo && !isSendingPromoCode) {
      var data = {
        gtm: {
          uniqueEventId: '82',
          elementId: "checkout-promoadd",
          promoName: newPromo
        },
        event: 'gtm.click'
      }; //post promoCode

      postPromoCode(newPromo); //clearValue

      changeHandler("");
      gaTracker(data);
    }
  };

  var removePromo = function removePromo(index) {
    deletePromoCode(savedPromos[index]);
  };

  var changeHandler = function changeHandler(a) {
    setPromoType(a);
  };

  var _handleKeyDown = function _handleKeyDown(e) {
    if (e.key === 'Enter') {
      promoHandler();
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__promo"
  }, /*#__PURE__*/React.createElement("p", null, "Apply a promo code"), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement("input", {
    disabled: validateSuccess || isSubmittingCart,
    className: "cb-form__input cb-form__input--full form-control",
    value: promoType,
    onChange: function onChange(e) {
      return changeHandler(e.target.value);
    },
    onKeyDown: _handleKeyDown
  })), savedPromos.map(function (promo, index) {
    return /*#__PURE__*/React.createElement(UsedPromo, {
      promoName: promo,
      id: "promo-".concat(index),
      remove: function remove() {
        return removePromo(index);
      }
    });
  }), /*#__PURE__*/React.createElement(StateButton, {
    loading: isSendingPromoCode || validateSuccess || isSubmittingCart,
    className: "cb-button-secondary w-100",
    id: "checkout-promoadd",
    onClick: promoHandler
  }, "Apply"));
};

var UsedPromo = function UsedPromo(_ref8) {
  var promoName = _ref8.promoName,
      remove = _ref8.remove,
      id = _ref8.id;
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-checkout__promo--used"
  }, /*#__PURE__*/React.createElement("span", null, promoName), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled",
    id: id,
    onClick: function onClick() {
      remove();
      var data = {
        gtm: {
          uniqueEventId: '83',
          elementId: id,
          promoName: promoName,
          type: "remove"
        },
        event: 'gtm.click'
      };
      gaTracker(data);
    }
  }, /*#__PURE__*/React.createElement(FaTimes, null)));
};

var expectedReadyTime = function expectedReadyTime(time) {
  var toMoment = time.TimeWanted ? time.TimeWanted : time.EarliestReadyTime;

  try {
    var momentObj = moment(toMoment, "YYYYMMDD hh:mm");
    var today = moment().endOf('day');
    var tomorrow = moment().add(1, 'day').endOf('day');

    if (momentObj < today) {
      return "Today at ".concat(momentObj.format("hh:mm A"));
    }

    if (momentObj < tomorrow) return "Tomorrow at ".concat(momentObj.format("hh:mm A"));
    return "".concat(momentObj.format("MMMM Do [at] hh:mm A"));
  } catch (_unused) {
    return "Unknown";
  }
};

export var CompletionModal = function CompletionModal(props) {
  var _fields$Header, _fields$Headline, _fields$SecondaryHead, _cost$Total;

  var _props$cart3 = props.cart,
      cart = _props$cart3 === void 0 ? {} : _props$cart3,
      _props$food = props.food,
      food = _props$food === void 0 ? {} : _props$food,
      _props$cater = props.cater,
      cater = _props$cater === void 0 ? {} : _props$cater,
      _props$cost2 = props.cost,
      cost = _props$cost2 === void 0 ? {
    Total: 30
  } : _props$cost2,
      _props$changeCheckout = props.changeCheckoutSuccess,
      changeCheckoutSuccess = _props$changeCheckout === void 0 ? function () {
    return "";
  } : _props$changeCheckout,
      _props$checkoutSucces = props.checkoutSuccess,
      checkoutSuccess = _props$checkoutSucces === void 0 ? false : _props$checkoutSucces,
      _props$submitInfo = props.submitInfo,
      submitInfo = _props$submitInfo === void 0 ? {} : _props$submitInfo,
      isCatering = props.isCatering,
      isFood = props.isFood,
      _props$deliveryMethod5 = props.deliveryMethod,
      deliveryMethod = _props$deliveryMethod5 === void 0 ? {} : _props$deliveryMethod5,
      fields = props.fields;
  var foodMethod = deliveryMethod.foodDeliveryMode || "";
  var caterMethod = deliveryMethod.caterDeliveryMode || "";
  var foodTimeBool = Boolean(isFood) && (food.EarliestReadyTime || food.TimeWanted);
  var caterTimeBool = Boolean(isCatering) && (cater.EarliestReadyTime || cater.TimeWanted);
  var deliveryChargeBool = Boolean(cater.DeliveryCharge || food.DeliveryCharge);
  return /*#__PURE__*/React.createElement(SolidModal, {
    show: checkoutSuccess,
    hide: function hide() {
      changeCheckoutSuccess(false);
      setTimeout(function () {
        window.location.pathname = "/";
      }, 1000);
    },
    title: fields === null || fields === void 0 ? void 0 : (_fields$Header = fields.Header) === null || _fields$Header === void 0 ? void 0 : _fields$Header.value,
    className: "solid-modal--thanks",
    size: "sm",
    subtitle: fields === null || fields === void 0 ? void 0 : (_fields$Headline = fields.Headline) === null || _fields$Headline === void 0 ? void 0 : _fields$Headline.value
  }, Boolean(foodTimeBool || caterTimeBool || deliveryChargeBool) && /*#__PURE__*/React.createElement("div", {
    className: "solid-modal--thanks__foodtime"
  }, /*#__PURE__*/React.createElement("span", {
    className: "solid-modal--thanks__readytime"
  }, fields === null || fields === void 0 ? void 0 : (_fields$SecondaryHead = fields.SecondaryHeadline) === null || _fields$SecondaryHead === void 0 ? void 0 : _fields$SecondaryHead.value), foodTimeBool && /*#__PURE__*/React.createElement("p", null, "Food (", UTIL.capitalizeFirstLetter(foodMethod), ") expected ready time: ", expectedReadyTime(food)), caterTimeBool && /*#__PURE__*/React.createElement("p", null, "Catering (", UTIL.capitalizeFirstLetter(caterMethod), ") expected ready time: ", expectedReadyTime(cater)), deliveryChargeBool && /*#__PURE__*/React.createElement("p", null, "Delivery times may vary")), /*#__PURE__*/React.createElement("div", {
    className: "solid-modal--thanks__thanks"
  }, /*#__PURE__*/React.createElement("p", null, "Thank you for shopping with us!"), /*#__PURE__*/React.createElement("p", null, "Your total is $", (_cost$Total = cost.Total) === null || _cost$Total === void 0 ? void 0 : _cost$Total.toFixed(2)), Boolean(submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.FoodOrderId) && /*#__PURE__*/React.createElement("p", null, "Food Order Confirmation Number: ", submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.FoodOrderId), Boolean(submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.CateringOrderId) && /*#__PURE__*/React.createElement("p", null, "Cater Order Confirmation Number: ", submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.CateringOrderId), Boolean(submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.RetailOrderId) && /*#__PURE__*/React.createElement("p", null, "Retail Order Confirmation Number: ", submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.RetailOrderId)), Boolean(foodMethod === "curbside" || caterMethod === "curbside") && /*#__PURE__*/React.createElement("div", {
    className: "solid-modal--thanks__savetime"
  }, /*#__PURE__*/React.createElement("strong", null, "Save time and check in online!"), /*#__PURE__*/React.createElement("p", null, "Select the \"I'm Here\" button in your confirmation email to let us know when you arrive-- no need to call!")), Boolean(isFood) && /*#__PURE__*/React.createElement("p", {
    className: "eatconfid visuallyhidden"
  }, submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.ConfirmationId), Boolean(isCatering) && /*#__PURE__*/React.createElement("p", {
    className: "cateringconfid visuallyhidden"
  }, submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.ConfirmationId), /*#__PURE__*/React.createElement("span", {
    className: "universalorder visuallyhidden"
  }, submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.ConfirmationId), /*#__PURE__*/React.createElement("span", {
    className: "cartsubtotal visuallyhidden"
  }, cost.Subtotal), /*#__PURE__*/React.createElement("span", {
    className: "displayname visuallyhidden"
  }, Array.isArray(cart) && cart.map(function (item, index) {
    return (index ? ", " : "") + "".concat(item.Product.DisplayName);
  })), /*#__PURE__*/React.createElement("span", {
    className: "productid visuallyhidden"
  }, Array.isArray(cart) && cart.map(function (item, index) {
    return (index ? ", " : "") + "".concat(item.Product.SitecoreId);
  })), Boolean(isFood) && /*#__PURE__*/React.createElement("span", {
    className: "fooddeliverytype visuallyhidden"
  }, deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.foodDeliveryMode), Boolean(isFood) && /*#__PURE__*/React.createElement("span", {
    className: "ordertype visuallyhidden"
  }, "EAT"), Boolean(isCatering) && /*#__PURE__*/React.createElement("span", {
    className: "cateringdeliverytype visuallyhidden"
  }, deliveryMethod === null || deliveryMethod === void 0 ? void 0 : deliveryMethod.caterDeliveryMode), Boolean(isCatering) && /*#__PURE__*/React.createElement("span", {
    className: "ordertype visuallyhidden"
  }, "CATER"), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary w-100",
    onClick: function onClick() {
      changeCheckoutSuccess(false);
      window.sessionStorage.removeItem('tmpMobilePayPegsEarned');
      setTimeout(function () {
        window.location.pathname = "/";
      }, 1000);
    }
  }, "Close"), /*#__PURE__*/React.createElement("div", {
    className: "solid-modal--thanks__peg"
  }, /*#__PURE__*/React.createElement(PegModule, {
    isThankYouModal: true,
    store: props.store,
    authenticationState: props.authenticationState,
    fields: (fields === null || fields === void 0 ? void 0 : fields.PegModule) && fields.PegModule.length >= 1 ? fields.PegModule[0].fields : {}
  })));
};

var CheckoutCheckbox = function CheckoutCheckbox(_ref9) {
  var _ref9$onClick = _ref9.onClick,
      onClick = _ref9$onClick === void 0 ? function () {
    return "";
  } : _ref9$onClick,
      _ref9$checked = _ref9.checked,
      checked = _ref9$checked === void 0 ? false : _ref9$checked,
      _ref9$className = _ref9.className,
      className = _ref9$className === void 0 ? "" : _ref9$className,
      _ref9$label = _ref9.label,
      label = _ref9$label === void 0 ? "" : _ref9$label;
  return /*#__PURE__*/React.createElement(FormGroup, {
    className: "cb-checkout__checkbox-group"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: className,
    checked: checked,
    onClick: onClick
  }), /*#__PURE__*/React.createElement("label", null, label));
};

export var RewardsRedeemedModule = function RewardsRedeemedModule(props) {
  var _props$cart5, _props$cart5$cartBefo, _TotalSavingsLabel$va;

  var _props$model = props.model,
      Image = _props$model.Image,
      TotalSavingsLabel = _props$model.TotalSavingsLabel;

  var _useState35 = useState(0),
      _useState36 = _slicedToArray(_useState35, 2),
      totalDiscount = _useState36[0],
      setTotalDiscount = _useState36[1];

  var _useState37 = useState(false),
      _useState38 = _slicedToArray(_useState37, 2),
      show = _useState38[0],
      setShow = _useState38[1];

  useEffect(function () {
    var asyncFunc = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _props$rewardsState, _props$cart4, _props$cart4$cart;

        var responseTotalDiscount;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(((_props$rewardsState = props.rewardsState) === null || _props$rewardsState === void 0 ? void 0 : _props$rewardsState.redeemedRewards) && ((_props$cart4 = props.cart) === null || _props$cart4 === void 0 ? void 0 : (_props$cart4$cart = _props$cart4.cart) === null || _props$cart4$cart === void 0 ? void 0 : _props$cart4$cart.length) > 0)) {
                  _context3.next = 14;
                  break;
                }

                _context3.prev = 1;
                _context3.next = 4;
                return props.redeemRewardsCart(props.rewardsState.redeemedRewards.type);

              case 4:
                responseTotalDiscount = _context3.sent;
                setTotalDiscount(responseTotalDiscount);

                if (parseFloat(responseTotalDiscount) === 0) {
                  setShow(false);
                } else {
                  setShow(true);
                }

                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                console.error('Error during redeem cart checkout', _context3.t0.message);

              case 12:
                _context3.next = 15;
                break;

              case 14:
                setShow(false);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 9]]);
      }));

      return function asyncFunc() {
        return _ref10.apply(this, arguments);
      };
    }();

    asyncFunc();
  }, [props.rewardsState, (_props$cart5 = props.cart) === null || _props$cart5 === void 0 ? void 0 : (_props$cart5$cartBefo = _props$cart5.cartBeforeRewards) === null || _props$cart5$cartBefo === void 0 ? void 0 : _props$cart5$cartBefo.cart_org]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement(Container, {
    className: "cb-checkout__section-container cb-checkout__rewards-redeemed-module"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-checkout__rewards-redeemed-module__logo-image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    className: "cb-checkout__rewards-redeemed-module__logo-image"
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-checkout__rewards-redeemed-module__total-savings-container'
  }, /*#__PURE__*/React.createElement("span", null, TotalSavingsLabel === null || TotalSavingsLabel === void 0 ? void 0 : (_TotalSavingsLabel$va = TotalSavingsLabel.value) === null || _TotalSavingsLabel$va === void 0 ? void 0 : _TotalSavingsLabel$va.replace('<total savings>', "$".concat(parseFloat(totalDiscount).toFixed(2)))))));
};